import DOMPurify from 'dompurify';

export class TrustedTypes {
    static createTrustedTypePolicy = () => {
        if (!window.trustedTypes) return;
        if (window.trustedTypes.defaultPolicy) return;

        try {
            window.trustedTypes.createPolicy('default', {
                createHTML: (toSanitize: string) => DOMPurify.sanitize(toSanitize, { RETURN_TRUSTED_TYPE: false }),
                createScriptURL: (toSanitize: string) => DOMPurify.sanitize(toSanitize, { RETURN_TRUSTED_TYPE: false }),
            });
        } catch {
            // policy already exists
        }
    };
}

export default TrustedTypes;
